// ** React Imports
import { useRef, useState } from 'react';

// ** Custom Components
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Wizard from '@components/wizard';

// ** Steps
import RoadDetails from './components/RoadDetails';
import ContentCreator from './components/ContentCreator';
import { CreateRoad, UpdateRoad } from '../../../../graphql/Mutation';
import { useMutation } from '@apollo/client';
const MySwal = withReactContent(Swal);

const WizardHorizontal = ({ defaultValues, editMode = false, roadId = '' }) => {
  const [data, setData] = useState(defaultValues);
  const [createRoad] = useMutation(CreateRoad);
  const [updateRoad] = useMutation(UpdateRoad);
  // ** Ref
  const ref = useRef(null);

  // ** State
  const [stepper, setStepper] = useState(null);

  const handleState = async (_data, done) => {
    const dataFormated = {
      ...data,
      ..._data,
      status: String(_data.status || data.status) === 'true'
    };
    setData(() => dataFormated);
    try {
      if (done) {
        if (!editMode) {
          await createRoad({
            variables: {
              createRoadInput: dataFormated
            }
          });
        } else {
          await updateRoad({
            variables: {
              updateRoadInput: {
                _id: roadId,
                data: dataFormated
              }
            }
          });
        }
        MySwal.fire({
          title: editMode ? 'Camino actualizado!' : 'Camino creado!',
          text: editMode
            ? 'Camino actualizado con exito!'
            : 'El camino fue creado con exito!',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        });
        window.location.href = '/roads/list';
      }
    } catch (e) {}
  };

  const steps = [
    {
      id: 'content-creator',
      title: 'Crear Contenido',
      subtitle: 'Carga episodios',
      content: (
        <ContentCreator
          stepper={stepper}
          handleOnSubmit={handleState}
          defaultValues={data}
        />
      )
    },
    {
      id: 'road-details',
      title: 'Detalles del Camino',
      subtitle: 'Datos básicos del camino.',
      content: (
        <RoadDetails
          stepper={stepper}
          handleOnSubmit={handleState}
          defaultValues={data}
          editMode={editMode}
        />
      )
    }
  ];

  return (
    <div className="horizontal-wizard">
      <Wizard instance={(el) => setStepper(el)} ref={ref} steps={steps} />
    </div>
  );
};

export default WizardHorizontal;
